import axios from "axios";
import { handleApiError } from "../Utils/errorUtils";
import { hideGlobalLoader, showGlobalLoader } from "../Utils/loaderController";
import Swal from "sweetalert2";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "https://acwadam.org",//"http://45.113.227.70:8001",
  timeout: 30000,
});

//request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    showGlobalLoader();
    const token = sessionStorage.getItem("adminToken");
    if (token) {
      config.headers = {
        ...config.headers, // Important for file uploads
        Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-store'
      }
    }
    return config;
  },
  (error) => {
    hideGlobalLoader();
    return Promise.reject(error)
  }
);

// response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    hideGlobalLoader();
    return response
  },
  (error) => {
    hideGlobalLoader();
    if (!navigator.onLine) {
      // Show offline message (toast, alert, or modal)
      Swal.fire({
        title: "Error!",
        icon: "error",
        text: "You are currently offline. Please check your internet connection.",
        confirmButtonText: "Ok",
      });
      // You could also return a custom rejected Promise if needed
      return Promise.reject({ message: "You are currently offline. Please check your internet connection.", isOffline: true });
    }

    // 🔁 Handle other API errors
    return handleApiError(error);
  }
);

export default axiosInstance;
